import React from 'react';

const notFoundPage = () => {
    return (
        <React.Fragment>
            <div className="banner-choose-deal flex-center" style={{backgroundImage: "url('"+process.env.PUBLIC_URL+"/image/banner-choose.png')"}}>
                <h4 className="banner-choose-deal-heading">404 Not Found</h4>
            </div>
        </React.Fragment>
    )
}

export default notFoundPage;